(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-joint-landing"] && !Shopify.designMode) return;
  try {
    
function initJointLanding(root) {
  if (root.dataset.jointReady) return;
  root.dataset.jointReady = 'true';
  const radios = [...root.querySelectorAll('[data-joint-variant]')];
  const form = root.querySelector('.snj-form');
  const submit = root.querySelector('[data-joint-submit]');
  let ready = false;
  const handle = 'nutraharmony-joint-support';
  function updateSelection() {
    const selected = radios.find(radio => radio.checked);
    if (!selected) return;
    root.querySelectorAll('[data-joint-price]').forEach(el => { el.textContent = selected.dataset.price; });
    submit.disabled = !ready || selected.dataset.available !== 'true';
    root.querySelector('[data-joint-button-text]').textContent = !ready ? 'Cargando formulario…' : submit.disabled ? 'Agotado' : 'PEDIR CONTRA ENTREGA';
    root.querySelectorAll('[data-joint-pick]').forEach(button => { button.disabled = submit.disabled; });
  }
  function syncOffers(detail) {
    if (detail?.productHandle !== handle) return;
    ready = true;
    radios.forEach(radio => {
      const offer = detail.offers.find(item => item.quantity === Number(radio.value));
      radio.disabled = !offer;
      radio.dataset.available = String(Boolean(offer));
      if (offer) {
        radio.dataset.price = offer.formattedPrice;
        root.querySelectorAll('[data-joint-offer-price="'+radio.value+'"]').forEach(el => { el.textContent = offer.formattedPrice; });
      }
    });
    if (!radios.some(radio => radio.checked && !radio.disabled)) { const first = radios.find(radio => !radio.disabled); if (first) first.checked = true; }
    updateSelection();
  }
  function order() {
    const selected = radios.find(radio => radio.checked);
    if (!ready || !selected || selected.disabled || submit.disabled) return;
    window.dispatchEvent(new CustomEvent('fsj:open-order',{detail:{productHandle:handle,quantity:Number(selected.value)}}));
  }
  radios.forEach(radio => radio.addEventListener('change', updateSelection));
  submit.addEventListener('click',order);
  root.querySelectorAll('[data-joint-pick]').forEach(button => button.addEventListener('click',() => {
    const radio = radios.find(item => item.value === button.dataset.jointPick);
    if (radio && !radio.disabled) { radio.checked = true; updateSelection(); order(); }
  }));
  window.addEventListener('fsj:offers',event => syncOffers(event.detail));
  if (window.__fsjOffers) syncOffers(window.__fsjOffers);
  updateSelection();
  const thumbs = [...root.querySelectorAll('[data-joint-thumb]')];
  function showImage(index) {
    const button = thumbs[(index + thumbs.length) % thumbs.length];
    root.querySelectorAll('[data-joint-image]').forEach(image => { image.hidden = image.dataset.jointImage !== button.dataset.jointThumb; });
    thumbs.forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb === button)); });
    root.querySelector('[data-joint-counter]').textContent = (Number(button.dataset.jointThumb) + 1) + ' / ' + thumbs.length;
    root.querySelector('[data-joint-zoom]').href = button.dataset.fullSource;
    button.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'});
  }
  thumbs.forEach((button,index) => button.addEventListener('click', () => showImage(index)));
  root.querySelector('[data-joint-prev]').addEventListener('click', () => showImage(thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true') - 1));
  root.querySelector('[data-joint-next]').addEventListener('click', () => showImage(thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true') + 1));
  const sticky = root.querySelector('[data-joint-sticky]');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      const entry = entries[0];
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > window.innerHeight;
    }, {threshold: 0}).observe(form);
  }
  root.querySelector('[data-joint-sticky-buy]').addEventListener('click',order);
}
document.querySelectorAll('[data-joint-root]').forEach(initJointLanding);
document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-joint-root]').forEach(initJointLanding); });

  } catch(e) { console.error(e); }
})();
})();
